import { render } from "./PostCarousel.vue?vue&type=template&id=3bfdad9e&scoped=true"
import script from "./PostCarousel.vue?vue&type=script&lang=js"
export * from "./PostCarousel.vue?vue&type=script&lang=js"

import "./PostCarousel.vue?vue&type=style&index=0&id=3bfdad9e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfdad9e"]])

export default __exports__